import type { MaritalStatusFormData } from "@porchpass/ui";
import type { UpdateBorrowerStatusFormData } from "src/types/borrower";

export function parseDependentsAgesString(
  value?: string,
): number[] | undefined {
  if (!value?.trim()) return undefined;

  const ages = value
    .split(",")
    .map((part) => part.trim())
    .filter((part) => part !== "" && !Number.isNaN(Number(part)))
    .map(Number);

  return ages.length > 0 ? ages : undefined;
}

function dependentsAgesFromDto(
  dto: UpdateBorrowerStatusFormData,
): number[] | undefined {
  if (dto.originalDependentsArray && dto.originalDependentsArray.length > 0) {
    return dto.originalDependentsArray;
  }

  return parseDependentsAgesString(dto.dependents_ages_years);
}

export function toMaritalStatusFormData(
  dto: UpdateBorrowerStatusFormData,
): MaritalStatusFormData {
  return {
    maritalStatus: "",
    dependentsAgesYears: dependentsAgesFromDto(dto),
  };
}

export function fromDependentsFormData(
  dependentsAgesYears?: number[],
): Partial<UpdateBorrowerStatusFormData> {
  return {
    dependents_ages_years: dependentsAgesYears?.length
      ? dependentsAgesYears.join(",")
      : "",
    originalDependentsArray: dependentsAgesYears,
  };
}
